module.exports = __webpack_public_path__ + "static/img/app_bg.7bb1cc0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/app_bg.png
// module id = 79
// module chunks = 2